/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_New_TitleInputs */

const vi_pdc_new_title = /** @type {(inputs: Pdc_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu điều chuyển`)
};

/**

* @param {Pdc_New_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_new_title = /** @type {((inputs?: Pdc_New_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_New_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_new_title(inputs)
});